import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'myfilter' })
export class MyFilterPipe implements PipeTransform {
    public transform(items: any[], searchText: string): any[] {
        const text = searchText && searchText.toLocaleLowerCase();

        const filtered = [];
        if (items) {
            for (const item of items) {
                if (!text
                    || item.value && item.value.find((child: any) => this.isInclude(child.name, text))
                    || item.name && this.isInclude(item.name, text)) {
                    filtered.push(item);
                }
            }
        }

        return filtered;
    }

    private isInclude(value: string, searchText: string): boolean {
        return value.toLowerCase().includes(searchText);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-list2/myfilter.pipe.ts